import { atom } from 'recoil';

export const CashoutOnboardingStatuses = {
  idle: 'idle',
  submitted: 'submitted',
};

const KEY = 'cashoutOnboardingStatusAtom';

export default atom({
  key: KEY,
  default: CashoutOnboardingStatuses.idle,
});
